import ModalAccountPending from './ModalAccountPending';

export default ModalAccountPending;
